<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!verificarPermissao('PERM_INSERIR_CONTA')">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="verificarPermissao('PERM_INSERIR_CONTA')">
			<h5>Configuração da Agenda</h5>
			<form #f="ngForm" name="form" novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
					</div>

					<p-tabView styleClass="tabview-custom">
						<p-tabPanel header="empresa">
							<ng-template pTemplate="header">
								<i class="pi pi-briefcase mr-1"></i>
								<span>Empresa</span>
							</ng-template>

							<div class="p-fluid p-formgrid grid">
								<div class="col-12 md:col-12">
									<h6>Adicionar Configuração</h6>
								</div>
								<div class="field col-12 md:col-4">
									<label htmlFor="diaSemana">Dia da Semana</label>
									<p-dropdown [options]="dias" optionLabel="dia" name="diaSemana" ngModel
										#diaSemana="ngModel" emptyMessage="Nenhum registro"
										placeholder="Selecione o dia" [(ngModel)]="diaSselecionadoConfEmpresa">
									</p-dropdown>
								</div>

								<div class="field col-12 md:col-2">
									<label htmlFor="inicio">Inicio</label>
									<input type="time" class="form-control" name="inicio" ngModel
										[(ngModel)]="horaIniioConfEmpresa" #inicio="ngModel" [required]="true" />

								</div>

								<div class="field col-12 md:col-2">
									<label htmlFor="fim">Fim</label>
									<input type="time" class="form-control" name="fim" ngModel
										[(ngModel)]="horaFimConfEmpresa" #fim="ngModel" [required]="true" />
								</div>

								<div class="field col-12 md:col-2">
									<div class="p-fluid">
										<button type="button" pButton icon="pi pi-check"
											class="p-button-success mt-5 mr-1" (click)="salvarConfEmpresa()"
											pTooltip="Adicionar"></button>
									</div>
								</div>
								<div class="col-12 md:col-12">
									<h6>Configurações Adicionadas na Agenda</h6>
								</div>

								<div class="field col-12 md:col-12">
									<p-table #tbConfsEmpresa [value]="confsEmpresa" dataKey="id" [paginator]="false"
										responsiveLayout="scroll" styleClass=" p-datatable-sm">
										<ng-template pTemplate="header">
											<tr>
												<th>Dia</th>
												<th>Hora Inicio</th>
												<th>Hora Fim</th>
												<th>Ações</th>
											</tr>
										</ng-template>
										<ng-template pTemplate="body" let-item let-i="rowIndex">
											<tr>
												<td>
													<label> {{ mostarDia(item.diaSemanaId) }} </label>
												</td>
												<td>
													<label>{{ item.horaInicio? item.horaInicio.substring(0, 5) : ''
														}}</label>
												</td>
												<td>
													<label>{{ item.horaFim? item.horaFim.substring(0, 5) : '' }}</label>
												</td>
												<td>
													<button pButton pRipple pTooltip="Excluir" type="button"
														icon="pi pi-trash" class="p-button-danger"
														(click)="excluirConfEmpresa(item.id)">
													</button>
												</td>
											</tr>

										</ng-template>
										<ng-template pTemplate="emptymessage">
											<tr>
												<td colspan="7">Nenhum registro encontrado.</td>
											</tr>
										</ng-template>
									</p-table>
								</div>
							</div>


						</p-tabPanel>

						<p-tabPanel header="profissionais" [cache]="true">
							<ng-template pTemplate="header">
								<i class="pi pi-users mr-1"></i>
								<span>Profissionais</span>
							</ng-template>
							<ng-template pTemplate="content">
								<div class="p-fluid p-formgrid grid">
									<div class="col-12 md:col-12">
										<h6>Adicionar Configuração</h6>
									</div>

									<div class="field col-12 md:col-3">
										<label htmlFor="profissionalConf">Profissional</label>
										<p-dropdown [options]="profissionaisAgenda" optionLabel="nomeProfissional"
											name="profissionalConf" ngModel #profissionalConf="ngModel"
											emptyMessage="Nenhum registro" placeholder="Selecione o rofissiona"
											[(ngModel)]="profissionaisSelecionadoConfProfissional">
										</p-dropdown>
									</div>
									<div class="field col-12 md:col-3">
										<label htmlFor="diaSemanaColaborador">Dia da Semana</label>
										<p-dropdown [options]="dias" optionLabel="dia" name="diaSemanaColaborador"
											ngModel #diaSemanaColaborador="ngModel" emptyMessage="Nenhum registro"
											placeholder="Selecione o dia" [(ngModel)]="diaSselecionadoConfProfissional">
										</p-dropdown>
									</div>

									<div class="field col-12 md:col-2">
										<label htmlFor="inicioConfColaborador">Inicio</label>
										<<input type="time" class="form-control" name="inicioConfColaborador" ngModel
											[(ngModel)]="horaIniioConfProfissional" #inicioConfColaborador="ngModel"
											[required]="true" />
									</div>

									<div class="field col-12 md:col-2">
										<label htmlFor="fimConfColaborador">Fim</label>
										<<input type="time" class="form-control" name="fimConfColaborador" ngModel
											[(ngModel)]="horaFimConfProfissional" #fimConfColaborador="ngModel"
											[required]="true" />
									</div>

									<div class="field col-12 md:col-2">
										<div class="p-fluid">
											<button type="button" pButton icon="pi pi-check"
												class="p-button-success mt-5 mr-1" (click)="salvarConfColaborador()"
												pTooltip="Adicionar" [disabled]="loadingTableProfissionais"></button>
										</div>
									</div>
									<div class="col-12 md:col-12">
										<h6>Profissionais Habilitados na Agenda</h6>
									</div>

									<div class="field col-12 md:col-12">
										<p-table #tbConfsProfissionais [value]="confsProfossionais" dataKey="id" [loading]="loadingTableProfissionais"
											[paginator]="false" responsiveLayout="scroll" styleClass=" p-datatable-sm">

											<ng-template pTemplate="caption">
												<div class="flex justify-content-start flex-column sm:flex-row">
													<p-dropdown [options]="profissionaisConfigurados" optionLabel="nomeProfissional" placeholder="Selecione"
														emptyFilterMessage="Nenhum registro" name="filtroProfissional" ngModel #filtroProfissional="ngModel"
														[(ngModel)]="profissionalConfiguradoSelecionado" (onChange)="listarConfsProfissioanis()">
													</p-dropdown>
												</div>
											</ng-template>
											<ng-template pTemplate="header">
												<tr>
													<th>Profissional</th>
													<th>Dia</th>
													<th>Hora Inicio</th>
													<th>Hora Fim</th>
													<th>Ações</th>
												</tr>
											</ng-template>
											<ng-template pTemplate="body" let-item let-i="rowIndex">
												<tr>
													<td>
														<label> {{ item.profissional.nomeProfissional }} </label>
													</td>
													<td>
														<label> {{ mostarDia(item.diaSemanaId) }} </label>
													</td>
													<td>
														<label>{{ item.horaInicio? item.horaInicio.substring(0, 5) :
															''}}</label>
													</td>
													<td>
														<label>{{ item.horaFim? item.horaFim.substring(0, 5) : ''
															}}</label>
													</td>
													<td>
														<button pButton pRipple pTooltip="Excluir" type="button"
															icon="pi pi-trash" class="p-button-danger"
															(click)="excluirConfProfissional(item.id)">
														</button>
													</td>
												</tr>

											</ng-template>
											<ng-template pTemplate="emptymessage">
												<tr>
													<td colspan="7">Nenhum registro encontrado.</td>
												</tr>
											</ng-template>
										</p-table>
									</div>
								</div>
							</ng-template>
						</p-tabPanel>


					</p-tabView>



				</div>
			</form>
			<p-confirmDialog [style]="{width: '50vw'}">
            </p-confirmDialog>
		</div>
	</div>
</div>